<template>
    <div v-if="backdrop">
        <div
            class="modal fade"
            :class="modal.open ? 'show' : ''"
            style="display: block"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
            @click="$event.target.classList.contains('modal') ? close() : true"
        >
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"> Detail Surat Konfirmasi Piutang </h5>
                        <button type="button" class="close" @click="close()" v-html="loadingData ? spin() : ic('close')"/>
                    </div>
                    <div class="modal-body default">
                        <div class="mb-3 d-flex col-12">
                            <div class="col-6 d-flex">
                                <div class="col-4">
                                    <p class="mb-1">Nama Perusahaan</p>
                                    <p class="mb-1">Nama Depo</p>
                                    <p class="mb-1">Nama Toko</p>
                                </div>
                                <div class="col-8">
                                    <p class="mb-1">: {{surat_tagihan.nama_perusahaan}}</p>
                                    <p class="mb-1">: {{surat_tagihan.nama_depo}}</p>
                                    <p class="mb-1">: {{surat_tagihan.nama_toko}}</p>
                                </div>
                            </div>
                            <div class="col-6 d-flex">
                                <div class="col-4">
                                    <p class="mb-1">Tanggal Surat</p>
                                    <p class="mb-1">Nomor Surat</p>
                                </div>
                                <div class="col-8">
                                    <p class="mb-1">: {{surat_tagihan.tanggal_surat}}</p>
                                    <p class="mb-1">: {{surat_tagihan.nomor_surat}}</p>
                                </div>
                            </div>
                        </div>

                        <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loadingData" />
                        <Nodata v-if="!loadingData && !surat_tagihan" class="d-flex h-100 align-items-center justify-content-center card" style="min-height: 490px;" />
                        
                        <div class="box" v-if="!loadingData && surat_tagihan">
                            <div class="card table-responsive"  style="max-height: 490px; min-height: 490px;">
                                <table class=" table table-vcenter table-hover card-table table-control">
                                    <thead class="text-muted">
                                        <th>No Invoice</th>
                                        <th>Tanggal Deliver</th>
                                        <th>Tanggal Jatuh Temppo</th>
                                        <th>Total</th>
                                        <th>Sisa</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(detail_surat_tagihan, index) in surat_tagihan.details" :key="index">
                                            <td>{{ detail_surat_tagihan.no_invoice }}</td>
                                            <td>{{ dFormat(`${detail_surat_tagihan.delivered_at}`, 'dMY') }}</td>
                                            <td>{{ dFormat(detail_surat_tagihan.due_date,'dMY') }}</td>
                                            <td>{{ ribuan(detail_surat_tagihan.grand_total) }}</td>
                                            <td>{{ ribuan(detail_surat_tagihan.outstanding) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import { mapActions, mapState } from "vuex";

export default {
    name: "FormDetail",
    props:{
        id: '',
        isOpen: false
    },
    data(){
        return {
            loadingData: false,
            backdrop: false,
            modal: {
                open: false, 
            },
            form:{
                isTokoSearch: true,
                keywordSearchToko: '',
                perusahaans: [],
                depos: [],
                tokos: [],
                checkeds:[]
            },
        }
    },
    mixins: [helper],
    computed:{
        ...mapState('surat_tagihan', {
            surat_tagihan: state => state.datas.suratTagihan,
        }),
    },
    methods: {
        ...mapActions("surat_tagihan", ["showSuratTagihan"]),

        close() {
            this.$emit("update:isOpen", false);
        },
    },
    watch: {
        "isOpen": function(isOpen){
            if (isOpen) {
                this.backdrop = isOpen;
                this.showSuratTagihan(this.id)
                setTimeout(() => {
                    this.modal.open = isOpen;
                }, 100);
            } else {
                this.modal.open = isOpen;
                setTimeout(() => {
                    this.backdrop = isOpen;
                }, 100);
            }
        }
    }


}
</script>